import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { NgToastService } from 'ng-angular-popup';

import { ActivatedRoute, Router } from '@angular/router';
import { DialogContentExampleDialogComponent } from '../dialog-content-example-dialog/dialog-content-example-dialog.component';
import { Stage3navComponent } from '../stage3nav/stage3nav.component';
import { SendforapprovalComponent } from '@/app/components/projects/project-stages/project-brief/sendforapproval/sendforapproval.component';
import { ProjectStageApprovalComponent } from '@/app/components/projects/project-stages/project-stage-approval/project-stage-approval.component';
import { AccordionComponent } from '../../../project-stages/accordion/accordion.component';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { environment } from '@/app/environments/environment';
import { saveAs } from 'file-saver';
import { DialogboxComponent } from '@/app/components/projects/project-stages/plan-sections/dialogbox/dialogbox.component';
import { Subscription } from 'rxjs';
import { DrawingService } from '@/app/services/shared/drawing.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DocumentService } from '@/app/services/shared/document.service';
import { ProgressService } from '@/app/services/shared/progress.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { FilterToolComponent } from '../../../../global/filter-tool/filter-tool.component';
import { MatMenuModule } from '@angular/material/menu';
import { WrapperComponent } from '../../../wrapper/wrapper.component';
import { InitialDrawingInfoComponent } from '../initial-drawing-info/initial-drawing-info.component';
import { DrawingsDialogComponent } from '../drawings-dialog/drawings-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-designdocuments',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatIcon,
    Stage3navComponent,
    SendforapprovalComponent,
    ProjectStageApprovalComponent,
    DialogContentExampleDialogComponent,
    AccordionComponent,
    DialogboxComponent,
    FilterToolComponent,
    MatIconModule,
    MatMenuModule,
    WrapperComponent,
  ],
  templateUrl: './design-documents.component.html',
  styleUrl: './design-documents.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesignDocumentsComponent implements OnInit {
  readonly dialog = inject(MatDialog);
  fileUrl =
    'https://buildxy.rocksofttech.com/api/storage/organizations/projects/documents/XrpBJQLsZQ5giTDUjYqlTYX3Bxk36jezf6mjm7qF.png';
  files: any[] = [];
  baseUrl = environment.storageUrl;
  projectId: any;
  filesRecord: any = [];
  selectedTab = 'Drawings';
  projectIdNew: string;
  documentType: string;
  isExpandedMap: Record<string, boolean> = {};
  isCreate = false;
  progress1: number = 40; // 40% for the first progress bar
  progress2: number = 60; // 60% for the second progress bar
  progress3: number = 80; // 80% for the third progress bar
  isEdit = false;
  selectedFileIds = new Set<string>(); // Store selected file IDs
  selectAllChecked = false; 
  constructor(
    private router: Router,
    private projectsService: ProjectsService,
    private cdr: ChangeDetectorRef,
    private drawingService: DrawingService,
    private http: HttpClient,
    private documentService: DocumentService,
    private toast: NgToastService,
    private progressService: ProgressService,
    private GetProjectIdService: GetProjectIdService,
    private activatedRoute: ActivatedRoute,
  ) {}

  sortColumn = '';
  sortDirection = 'asc';
  sortedFiles = [...this.files];

  progress = 0;
  isStageThreeSendForApproval = false;
  private subscription: Subscription = new Subscription();

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.sortedFiles = this.files.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

  isSectionVisible = false;

  toggleSection() {
    this.isSectionVisible = !this.isSectionVisible;
  }
  toggleAdvancedOptions(fileId: number) {
    this.isExpandedMap[fileId] = !this.isExpandedMap[fileId];
  }
  toggleButtons(event: Event, fileId: any) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedFileIds.add(fileId);
    } else {
      this.selectedFileIds.delete(fileId);
    }
  }
  toggleSelectAll(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    this.selectAllChecked = checkbox.checked;
  
    if (this.selectAllChecked) {
      this.selectedFileIds = new Set(this.files.map(file => file.id)); // Select all
    } 
    
    else {
      this.selectedFileIds.clear(); // Deselect all
    }
  }
  deleteSelectedFiles() {
    const fileIds = Array.from(this.selectedFileIds);
    
    if (fileIds.length === 0) {
      this.toast.warning('No files selected for deletion', 'WARNING', 4000);
      return;
    }
  
    let deleteCount = 0;
    let errorOccurred = false;
  
    fileIds.forEach((fileId) => {
      this.projectsService.deleteDrawing(fileId).subscribe({
        next: () => {
          this.files = this.files.filter((file) => file.id !== fileId); // Remove deleted file
          this.selectedFileIds.delete(fileId); // Clear selection
          deleteCount++;
  
          // Show success toast only when all deletions are done
          if (deleteCount === fileIds.length && !errorOccurred) {
            this.toast.success(`${fileIds.length} File(s) Deleted Successfully`, 'SUCCESS', 4000);
            this.drawingService.notifyDrawingUpdate();
          }
           // If no files are left, uncheck the "Select All" checkbox
        if (this.files.length === 0) {
          this.selectAllChecked = false;
        }
        },
        error: (error) => {
          console.error(`Error deleting file ${fileId}:`, error);
          errorOccurred = true;
          this.toast.danger('Some files could not be deleted', 'DANGER', 4000);
        },
      });
    });
  }
 
  

  // You can create a method to update these progress values dynamically.
  updateProgress(progress1: number, progress2: number, progress3: number): void {
    this.progress1 = progress1;
    this.progress2 = progress2;
    this.progress3 = progress3;
  }
  ngOnInit(): void {
    this.drawingService.drawingUpdated$.subscribe(() => {
      this.loadDesignDocuments(this.documentType); // Reload drawings when notified
    });
    this.activatedRoute.paramMap.subscribe((params) => {
      const newDocumentType = params.get('document-type');
      if (newDocumentType && newDocumentType !== this.documentType) {
        this.documentType = newDocumentType;
        this.newTabselected(this.documentType);
        this.loadDesignDocuments(this.documentType);
      }
    });


    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectId = this.GetProjectIdService.getProjectId();
      }
      this.loadDesignDocuments(this.documentType);
    });

    this.progressService.progress3$.subscribe((value) => {
      this.progress = value;
    });
    this.checkStageThreeApproval();
  }


  newTabselected(documentType: string) {
    if (documentType === 'drawing') {
      this.selectedTab = 'Drawing';
    }else if (documentType === 'specifications') {
      this.selectedTab = 'Specifications';
    } else if (documentType === 'calculations') {
      this.selectedTab = 'Calculations';
    } else if (documentType === 'surverys_reports_studies') {
      this.selectedTab = 'Surveys, Reports and Studies';
    } else if (documentType === 'design_review_reports') {
      this.selectedTab = 'Design Review Reports';
    } else if (documentType === 'permits_and_applications') {
      this.selectedTab = 'Permits and Applications';
    } else if (documentType === 'design_signoff') {
      this.selectedTab = 'Design Sign Off';
    } else if (documentType === 'r_f_i') {
      this.selectedTab = 'RFI';
    }
  }

  // TODO: we will create a global function and move it there so it can be used for all six stages
  async checkStageThreeApproval(): Promise<void> {
    /**
     * send request to check if approval for stage 1 exists.
     * show component sendforapproval/project-stage-approval based on the result
     */
    const projectId = localStorage.getItem('projectId');
    if (!projectId) {
      // this.toast.danger('Project is not yet created', 'ERROR');
      console.log('Project is not yet created');
      return;
    }

    const data = {
      project_id: projectId,
      stage: 3, // as this is info component so stage will always be 3
    };

    try {
      const temp = await this.projectsService
        .getCurrentStageApproval(data)
        .toPromise();

      if (temp.data.length > 0) {
        this.isStageThreeSendForApproval = true;
      }
      // } catch (error) {
      //   this.toast.danger('Failed to fetch approval. Please try again.', 'ERROR', 4000);
    } catch (error) {
      console.log(error);
      
    }
  }

  handleRevision() {
    this.dialog.open(InitialDrawingInfoComponent, {
      width: '78vw',
      height: '80vh',
      maxWidth: 'unset',
      autoFocus: false,
        
    });
  }

  navigateTo(route: string) {
    this.router.navigate([`/${route}`]).catch((err) => {
      console.error(`Navigation to ${route} failed:`, err);
    });
  }
  openDialog() {
    if (this.selectedTab === 'Drawing') {
      this.dialog.open(DrawingsDialogComponent, {
        data: {
          documentType: this.documentType,
        },
      }).afterClosed().subscribe(() => {
        this.loadDesignDocuments(this.documentType);
      });
    } else {
      this.dialog
        .open(DialogContentExampleDialogComponent, {
          data: {
            documentType: this.documentType,
          },
        })
        .afterClosed()
        .subscribe(() => {
          this.loadDesignDocuments(this.documentType);
        });
    }
  }

  downloadFile(filePath: string, title: any): void {
    const fullPath = `${this.baseUrl}${filePath}`; // Append baseUrl with file_path
    const file_name = title;
    saveAs(fullPath, file_name);
  }
  viewFile(filePath: string): void {
    const fullPath = `${this.baseUrl}${filePath}`; // Construct full path of the file

    // Open the file in a new tab
    const newTab = window.open(fullPath, '_blank');
    if (!newTab) {
      console.warn(
        'Failed to open new tab. Please allow pop-ups for this website.'
      );
    }
  }
  
  downloadDocument(id: number, title: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.projectsService.downloadDocument(id, title).subscribe({
        next: (response: HttpResponse<Blob>) => {
          // Get the Blob data from the response body
          const blob = response.body;
          if (!blob) {
            reject(new Error('No file data received'));
            return;
          }
  
          // Extract filename from headers or use the provided title
          let filename = 'document';
          let extension = this.getFileExtensionFromBlob(blob); // Get extension from Blob type
          
          const contentDisposition = response.headers.get('content-disposition');
  
          if (contentDisposition) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
              // Use the extension from the filename if available
              extension = filename.split('.').pop()?.toLowerCase() || extension;
            }
          } else if (title) {
            // Remove any existing extension from title to avoid duplicates
            const titleWithoutExt = title.replace(/\.[^/.]+$/, "");
            filename = `${titleWithoutExt}.${extension}`;
          } else {
            filename = `document.${extension}`;
          }
  
          // Ensure filename has an extension
          if (!filename.includes('.')) {
            filename = `${filename}.${extension}`;
          }
  
          // Create a download link
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
  
          // Clean up
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          resolve();
        },
        error: (error) => {
          console.error('Error downloading file:', error);
          reject(error);
        }
      });
    });
  }
  
  // Helper function to get file extension from Blob type
  private getFileExtensionFromBlob(blob: Blob): string {
    const type = blob.type;
    
    // Common MIME types mapping
    const extensionMap: Record<string, string> = {
      'application/pdf': 'pdf',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'image/jpeg': 'image',
      'image/png': 'image',
      'image/gif': 'image',
      'image/svg+xml': 'image',
      'image/webp': 'image',
      'text/csv': 'csv',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    };
  
    return extensionMap[type] || 'bin'; // default to 'bin' if type is unknown
  }
  
  
  async downloadSelectedDocuments() {
    if (this.selectedFileIds.size === 0) return;
    for (const [id, title] of this.selectedFileIds) {
      try {
        // Convert string ID to number if needed
        await this.downloadDocument(Number(id), title);
        // Add a small delay between downloads if needed
        await new Promise(resolve => setTimeout(resolve, 500));
      } catch (error) {
        console.error(`Error downloading document with ID ${id}:`, error);
        // Continue with next document even if one fails
      }
    }
  }

  loadDesignDocuments(documenttype: string): void {
    this.projectsService.getDesignDocuments(documenttype).subscribe({
      next: (response: any) => {
        if (response.meta.code === 200 && response.meta.success) {
          this.files = response.data;
          const document_type = documenttype || '';
          this.documentService.setDocumentData(
            response.data.length,
            document_type
          );
          this.cdr.detectChanges();
        }
      },
      error: (error: any) => {
        console.error('Error fetching the project types:', error);
      },
    });
  }

  downloadFile1() {
    const anchor = document.createElement('a');
    anchor.href = this.fileUrl;
    anchor.download = 'document.png'; // Set a default file name here
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  get formattedSelectedTab(): string {
    return this.capitalizeFirstLetter(this.selectedTab);
  }

  capitalizeFirstLetter(value: string): string {
    return value.toUpperCase();
  }

  changeTab(currrentTab: string) {
    this.selectedTab = currrentTab;
    if (currrentTab === 'Drawing') {
      this.router.navigate(['/project-design', 'drawing']);
    } else if (currrentTab === 'Specifications') {
      this.router.navigate(['/project-design', 'specifications']);
    } else if (currrentTab === 'Calculations') {
      this.router.navigate(['/project-design', 'calculations']);
    } else if (currrentTab === 'Surveys, Reports and Studies') {
      this.router.navigate(['/project-design', 'surverys_reports_studies']);
    } else if (currrentTab === 'Design Review Reports') {
      this.router.navigate(['/project-design', 'design_review_reports']);
    } else if (currrentTab === 'Permits and Applications') {
      this.router.navigate(['/project-design', 'permits_and_applications']);
    } else if (currrentTab === 'Design Sign Off') {
      this.router.navigate(['/project-design', 'design_signoff']);
    } else if (currrentTab === 'RFI') {
      this.router.navigate(['/project-design', 'r_f_i']);
    }
  }
}
